'use strict';

const Marionette = require('backbone.marionette');
const $ = require('jquery');
const Radio = require('backbone.radio');
const { default: i18n } = require('i18next');
const _ = require('underscore');
const WarningView = require('./components/warningView');
const ErrorView = require('./components/msgBoxView');
const template = require('../templates/mfaonetime.hbs');

const navChannel = Radio.channel('controller');

const ajaxOptions = {
  url:    `${NETOP_CONFIG.SECURE_API}/nextStep`,
  method: 'POST',
};

const UserNameView = Marionette.ItemView.extend({
  template,
  tagName: 'div',
  ui:      {
    mfaRecoveryCode: '#mfaRecoveryCode',
    error:           '.error',
    closeA:          '.close',
    cancel:          '#cancel',
    form_group:      '.form-group',
    input_error:     '.input-error',
  },
  events: {
    'submit form':               'handleSubmit',
    'click @ui.closeA':          'handleCloseAlert',
    'click @ui.cancel':          'handleClickCancel',
    'input @ui.mfaRecoveryCode': 'onFocusMFACode',
    'focus @ui.mfaRecoveryCode': 'onFocusMFACode',
    'blur @ui.mfaRecoveryCode':  'onBlurMFACode',
  },
  handleCloseAlert: function fHandleCloseAlert(e) {
    e.preventDefault();
    this.ui.alert.hide();
  },

  onFocusMFACode: function fOnFocusMFACode() {
  },

  onBlurMFACode: function fOnBlurMFACode() {
  },

  handleClickCancel: function fHandleClickCancel(e) {
    e.preventDefault();
    navChannel.trigger('USERNAME');
  },

  handleSubmit: function fHandleSubmit(e) {
    e.preventDefault();

    const mfaRecoveryCode = this.ui.mfaRecoveryCode.val().trim();
    if (!mfaRecoveryCode) {
      this.warningView.show(i18n.t('common:mandatory-field'));
      this.errorView.hide();
      this.ui.mfaRecoveryCode.parent().addClass('has-error');
      this.ui.mfaRecoveryCode.focus();
      return;
    }

    this.model.set({
      mfaRecoveryCode,
    });

    $.ajax({
      url:    ajaxOptions.url,
      method: ajaxOptions.method,
      data:   {
        loginSessionId: this.model.get('loginSessionId'),
        currentStep:    'MFA_OTC',
        input:          this.model.get('mfaRecoveryCode'),
      },
    })
      .done((body) => {
        if (body.nextStep === 'ERROR' && !this.model.get('switchAccount')) {
          this.model.set(_.extend({}, body, (body.options || {})));
          navChannel.trigger(this.model.get('nextStep'));
          return;
        }

        if (body.options.error) {
          this.ui.mfaRecoveryCode.parent().addClass('has-error');
          this.ui.mfaRecoveryCode.val('');
          this.ui.mfaRecoveryCode.focus();

          switch (body.options.error) {
            case '6602':
              this.warningView.show(i18n.t('common:recovery-code-error'));
              this.errorView.hide();
              break;
            case '6603':
              this.warningView.show(i18n.t('common:recovery-code-used-error'));
              this.errorView.hide();
              break;
            default:
              console.error(`Error happened (error code: ${body.options.error})`);
              this.errorView.show(i18n.t('common:unknown-error'));
              this.warningView.hide();
              break;
          }
          return;
        }

        this.model.set({
          loginSessionId: body.loginSessionId,
          nextStep:       body.nextStep,
        });

        if (body.options.token) {
          this.model.set('token', body.options.token);
        }

        navChannel.trigger(this.model.get('nextStep'));
      })
      .fail((error) => {
        console.error(`Error happened (error code: ${error})`);
        this.errorView.show(i18n.t('common:unknown-error'));
        this.warningView.hide();
      });
  },
  onRender: function fOnRender() {
    this.warningView = new WarningView({
      el: this.ui.input_error,
    });
    this.errorView = new ErrorView({
      el: this.ui.error,
    });
    setTimeout(() => this.ui.mfaRecoveryCode.focus(), 1); // Doesn't work without timeout, cba with proper fix
  },
});

module.exports = UserNameView;
